var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Calendar',{attrs:{"datePickerShow":_vm.datePickerShow,"feeProps":_vm.feeProps},on:{"feeClose":_vm.closeFee}}),_c('div',{on:{"click":_vm.getFeeProps}},[_vm._v("dsdsds")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }